import Vue, { VueConstructor } from 'vue';
import { Game, Player, nextTurn, showCard } from '@/services';
import { queryString } from "get-query-strings";
import _ from 'lodash';

export default (Vue as VueConstructor<Vue & {
    $refs: {
        gameLink: HTMLInputElement,
        spyLink: HTMLInputElement
    };
}>).extend({
    props: {
        game: Object as () => Game,
        player: Object as () => Player
    },
    data() {
        return {
            showTooltip1: false,
            showTooltip2: false,
            gameOver: false
        };
    },
    computed: {
        gameLink(): string {
            return window.location.href.split('?')[0] + "?gid=" + this.game.gameId;
        },
        gameSpymasterLink(): string {
            return window.location.href.split('?')[0] + `?gid=${this.game.gameId}&spy=true`;
        },
        isMaster() {
            return this.player.role == "master";
        },
        agentsA() {
            return _.filter(this.game.agents, a => a.team == "A");
        },
        agentsB() {
            return _.filter(this.game.agents, a => a.team == "B");
        },
        masterA() {
            return this.game.masters && this.game.masters.length >= 1 ? this.game.masters[0].name : "";
        },
        masterB() {
            return this.game.masters && this.game.masters.length == 2 ? this.game.masters[1].name : "";
        },
        gameReady() {
            return this.game.masters.length == 2;
        },
        isCurrentMaster(): boolean {
            return this.isMaster && this.game.turn == this.player.team
        },
        points() {
            const shownCards = _.map(this.game.showCards, s => this.game.spymaster[s]),
                A = _.filter(shownCards, c => c == "A").length,
                B = _.filter(shownCards, c => c == "B").length;
            if (A == 9 || B == 8) this.gameOver = true;
            return {
                A,
                B
            }
        },
        assassinHit(): boolean {
            return _.some(this.game.showCards, s => this.game.spymaster[s] == "X");
        },
        isGameOver(): boolean {
            return this.gameOver || this.assassinHit;
        },
        currentTeam(): string {
            return this.game.turn;
        }
    },
    methods: {
        copyLink(input: HTMLInputElement) {
            input.select();
            input.setSelectionRange(0, 99999);
            /*For mobile devices*/
            document.execCommand("copy");
            if (input.name == "game") this.showTooltip1 = true;
            if (input.name == "spy") this.showTooltip2 = true;
            this.$nextTick(() => {
                this.showTooltip1 = false;
                this.showTooltip2 = false;
            });
        },
        newGame() {
            window.location.href = window.location.href.split('?')[0];
        },
        goToSpy() {
            window.location.href = this.gameSpymasterLink
        },
        spyClass(index: number) {
            const isShown = _.some(this.game.showCards, c => c == index),
                spy = `spy-${this.game.spymaster[index]}`;
            if (isShown) {
                return this.isMaster ? "grayed-out" : spy;
            }
            return this.isMaster || this.isGameOver ? spy : "";
        },
        showCard(index: number) {
            if (!this.isGameOver && this.isCurrentMaster) showCard(this.game, index);
        },
        nextTurn() {
            nextTurn(this.game);
        }
    },
    watch: {
        isGameOver() {
            this.$emit("game-over");
        },
        currentTeam(){
            document.body.className = this.game.turn == "A" ? "bg-red" : "bg-blue";
        }
    }
})